import {axios, API, SendRequest} from '@/imports-files/pages/clients/jobs/common';

export class JobCommon extends SendRequest {
  async destroyJob(jobId) 
  {
    try {
        const result = await axios.delete(API.client.jobs.DELETE_JOB.replace('$job_id', jobId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async saveAsDraft(params, jobId) {
    try {
      const result = await axios.patch(API.client.jobs.UPDATE_JOB.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async previewJob(client_auth_cookies, jobId, hostName) {
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.PREVIEW_JOB.replace('$job_id', jobId),
        headers: {cookie: `Authorization=${client_auth_cookies}`, SLUG: hostName},
        params: {},
      });
      return result;
    } catch (error) {
      return error;
    }
  }

  async viewJob(client_auth_cookies, slug) {
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.VIEW_JOB.replace('$slug', slug),
        headers: {cookie: `Authorization=${client_auth_cookies}`},
        params: {},
      });
      return result; 
    } catch (error) {
      return error;
    }
  }

  async closeJob(params, jobId) {
    try {
      const result = await axios.post(API.client.jobs.CLOSE_JOB.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async publishJob(jobId) {
    try {
      const result = await axios.post(API.client.jobs.PUBLISH_JOB.replace('$job_id', jobId),
        {},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async duplicateJob(jobId) {
    try {
      const result = await axios.post(API.client.jobs.DUPLICATE_JOB.replace('$job_id', jobId),
        {},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async editJob(jobId) {
    try {
      const result = await axios.get(API.client.jobs.CHECK_EDIT.replace('$job_id', jobId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }

  async getCandidateCv(client_auth_cookies,cv_token){
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.FETCH_CANDIDATE.replace('$cv_token', cv_token),
        headers: {cookie: `Authorization=${client_auth_cookies}`},
        params: {},
      });
      return result.data; 
    } catch (error) {
      return error;
    }
  }

  async getJobScorecard(client_auth_cookies, job_slug, token){
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.FETCH_SCORECARD.replace('$job_slug', job_slug),
        headers: {cookie: `Authorization=${client_auth_cookies}`},
        params: {token: token},
      });
      return result;
    } catch (error) {
      return error;
    }
  }

  async viewScreeningQuestions(client_auth_cookies, slug, token) {
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.VIEW_SCREENING_QUESTIONS.replace('$slug', slug),
        headers: {cookie: `Authorization=${client_auth_cookies}`},
        params: {token: token},
      });
      return result;
    } catch (error) {
      return error;
    }
  }

  async getCvUrl(client_auth_cookies, slug, token) {
    try {
      const result = await axios({
        method: 'get',
        url: API.client.jobs.FETCH_CANDIDATE_CV.replace('$slug', slug),
        headers: {cookie: `Authorization=${client_auth_cookies}`},
        params: {token: token},
      });
      return result;
    } catch (error) {
      return error;
    }
  }
}
